export const LUCK_PRINTER_SERVICE_UUID =
  "0000ff00-0000-1000-8000-00805f9b34fb";
export const LUCK_PRINTER_WRITE_CHAR_UUID =
  "0000ff02-0000-1000-8000-00805f9b34fb";
export const LUCK_PRINTER_NOTIFY_CHAR_UUID =
  "0000ff01-0000-1000-8000-00805f9b34fb";

export const LUCK_PRINT_WIDTH_PX = 384;
export const DEFAULT_FEED_DOTS = 80;
export const WEB_BLE_CHUNK_SIZE = 100;
export const WEB_BLE_CHUNK_DELAY_MS = 50;

export type LuckPrinterDensity = 0 | 1 | 2;

export function buildWakeCommand(): Uint8Array {
  return new Uint8Array(12);
}

export function buildEnablePrinterCommand(): Uint8Array {
  return new Uint8Array([0x10, 0xff, 0xf1, 0x03]);
}

export function buildSetDensityCommand(level: LuckPrinterDensity): Uint8Array {
  return new Uint8Array([0x10, 0xff, 0x10, 0x00, level]);
}

export function buildFeedPaperCommand(dots: number): Uint8Array {
  const n = Math.max(0, Math.min(255, Math.round(dots)));
  return new Uint8Array([0x1b, 0x4a, n]);
}

export function buildStopJobCommand(): Uint8Array {
  return new Uint8Array([0x10, 0xff, 0xf1, 0x45]);
}

/** Label gap: align to sticker start (first label in job). */
export function buildAdjustPositionStartCommand(): Uint8Array {
  return new Uint8Array([0x1f, 0x11, 0x51]);
}

/** Label gap: align after feed (last label in job). */
export function buildAdjustPositionEndCommand(): Uint8Array {
  return new Uint8Array([0x1f, 0x11, 0x50]);
}

/** Label gap: advance to next label gap. */
export function buildPositionToNextLabelCommand(): Uint8Array {
  return new Uint8Array([0x1d, 0x0c]);
}

/** Tattoo paper type (Luck Jingle tattoo mode). */
export function buildSetTattooPaperTypeCommand(): Uint8Array {
  return new Uint8Array([0x1f, 0x80, 0x01, 0x40]);
}

/** Luck Jingle content mode: 0 = text, 1 = image. */
export function buildSetPrinterModeCommand(mode: 0 | 1): Uint8Array {
  return new Uint8Array([0x10, 0xff, 0x30, 0x27, mode]);
}

export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
